import { setGetGameByIdAction } from '../action';
import { getGameById } from '../api/getGameById';

export const setGetGameById = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getGameById(params);

            dispatch(setGetGameByIdAction(data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}